import $ from 'jquery'

export const Filter = {
  HOOK_INPUT: '.js-filter', // Filter input
  HOOK_EMPTY: '.js-filter-empty', // Empty state message container
  HOOK_ENTER_MESSAGE: '.js-filter-message', // Label with the enter key message
  HOOK_SELECTION_NAME: '.js-filter-message-selection', // Populate the enter messages current selection
  HOOK_ITEM_CONTAINER: '.js-filter-container', // Container to dump fetched results in
  HOOK_ITEM: '.js-filter-item', // Items to filter
  HOOK_MORE: '.js-filter-more', // "Show More" button. Hide it when fetching results
  HOOK_ITEM_NAME: '.js-filter-name', // The item's element to scrape the name from
  HOOK_ITEM_LINK: '.js-filter-link', // The item's link
  HOOK_RESET: '.js-filter-reset', // The item's link
  item_batch: 0,

  init: function () {
    Filter.config()

    $(document).on('keydown', Filter.HOOK_INPUT, Filter.route)
    $(document).on('blur', Filter.HOOK_INPUT, Filter.blur)
    $(document).on('focus', Filter.HOOK_INPUT, Filter.focus)
    $(document).on('click', Filter.HOOK_RESET, Filter.reset)
    $(document).on('click', Filter.HOOK_MORE, Filter.showMore)

    // Clear out input when page loads
    $(Filter.HOOK_INPUT).val('')
  },

  config: function () {
    Filter.filterURI = $(Filter.HOOK_INPUT).data('filter-uri') || false // Check whether we're doing static filtering or server-side fetching
    Filter.delay = $(Filter.HOOK_INPUT).data('filter-delay') || 0 // How long to wait after user stops typing. Used as a way to rate limit server-side fetching.
  },

  route: function (event) {
    if ($(Filter.HOOK_ENTER_MESSAGE).length === 0) {
      Filter.getFilterText() === ''
        ? $(Filter.HOOK_RESET).addClass('hidden')
        : $(Filter.HOOK_RESET).removeClass('hidden')
    }

    // Clear timeout if the user keeps typing
    clearTimeout(Filter.timeout)

    // After delay filter the results
    Filter.timeout = setTimeout(function () {
      // Fetch the results if there's a filter URI
      Filter.filterURI ? Filter.fetchResults() : Filter.filterDOM(event)
    }, Filter.delay)
  },

  getFilterText: function () {
    return $(Filter.HOOK_INPUT).val().toLowerCase() || ''
  },

  fetchResults: function () {
    const filterText = Filter.getFilterText()
    const data = {
      text: filterText || '',
    }

    $(Filter.HOOK_ITEM_CONTAINER).addClass('u-is-loading')

    $.ajax({
      url: Filter.filterURI,
      data: data, // TODO: Get the correct data to be passed to rails
    }).done(function (response) {
      $(Filter.HOOK_ITEM_CONTAINER).empty().html(response)
      $(Filter.HOOK_ITEM_CONTAINER).removeClass('u-is-loading')
    })
  },

  filterDOM: function (event) {
    const $items = $(Filter.HOOK_ITEM)
    const filterText = Filter.getFilterText()

    $(Filter.HOOK_ITEM).removeClass('filter-item-active')

    if (filterText === '' || filterText === ' ') {
      Filter.resetDOM()
    } else {
      // A bulk hide of all items
      $items.hide()

      // Filter matched items
      const $newItems = $items.filter('[data-keywords*="' + filterText + '"]')

      // If there are results
      if ($newItems.length > 0) {
        // Show matched items
        $newItems.show()

        // Quick selection for first item in list
        $(Filter.HOOK_SELECTION_NAME).text(
          $newItems.find(Filter.HOOK_ITEM_NAME).first().text()
        )
        $(Filter.HOOK_ENTER_MESSAGE).removeClass('is-disabled')
        $(Filter.HOOK_RESET).addClass('hidden')

        // Navigate to the first item if enter key is pressed
        if (event && event.keyCode === 13) {
          // Find href
          // If child hook isn't found, look in the parent node
          const href =
            $newItems.find(Filter.HOOK_ITEM_LINK).first().attr('href') ||
            $newItems.first().attr('href')
          if (typeof href !== 'undefined') window.location = href
        }

        $newItems.first().addClass('filter-item-active')
      } else {
        // Show empty state
        $(Filter.HOOK_EMPTY).show()
        $(Filter.HOOK_ENTER_MESSAGE).addClass('is-disabled')
        $(Filter.HOOK_RESET).removeClass('hidden')
      }
    }
  },

  resetDOM: function () {
    // Show all the items
    $(Filter.HOOK_ITEM).show()

    // Hide empty state
    $(Filter.HOOK_EMPTY).hide()

    // Hide enter message
    $(Filter.HOOK_ENTER_MESSAGE).addClass('is-disabled')
  },

  blur: function () {
    // Hide the enter key message when the filter loses focus
    $(Filter.HOOK_ITEM).removeClass('filter-item-active')
    $(Filter.HOOK_ENTER_MESSAGE).addClass('is-disabled')
    Filter.getFilterText() === ''
      ? $(Filter.HOOK_RESET).addClass('hidden')
      : $(Filter.HOOK_RESET).removeClass('hidden')
  },

  focus: function () {
    if ($(this).val().length > 0) {
      Filter.route()
    }
  },

  reset: function (event) {
    event.preventDefault()

    $(Filter.HOOK_INPUT).val('').focus()
    $(this).addClass('hidden')
    Filter.filterURI ? Filter.fetchResults() : Filter.filterDOM()
  },

  showMore: function (event) {
    event.preventDefault()

    // Make sure it's not loading
    if (!$(Filter.HOOK_ITEM_CONTAINER).hasClass('u-is-loading')) {
      const filterID = $(Filter.HOOK_MORE).attr('data-filter-id')
      $(Filter.HOOK_ITEM_CONTAINER).addClass('u-is-loading')

      $.ajax({
        url: $(this).attr('href'),
      }).done(function (response) {
        // Remove older "more" link
        $(Filter.HOOK_MORE).parent().remove()

        // This lets us keep track of which items were added in batches
        const $items = $(response)
        Filter.item_batch++
        $items.filter(Filter.HOOK_ITEM).attr('data-batch', Filter.item_batch)

        // Add content to DOM and remove loader
        $(Filter.HOOK_ITEM_CONTAINER).append($items).removeClass('u-is-loading')

        // Trigger a custom event in case you want to do some updating of values somewhere else
        $(document).trigger('filter-items-loaded', { filterID: filterID })
      })
    }
  },
}

$(Filter.init)

/*
Example of DOM implementation

 <div class="filter">
   <p class="filter_message is-disabled js-filter-message"><span class="key-label">⏎ Enter</span> to choose <strong class="js-filter-message-selection"></strong>.</p>
   <a href="#" class="filter_reset js-filter-reset hidden">&times;</a>
   <input class="u-input u-input--search js-filter" type="text" placeholder="Find some item" autofocus>
 </div>

 <!-- Item -->
 <div class="js-filter-item" data-keywords="something keyword here">
   <h4 class="js-filter-name">Name of something</h4>
   <a href="#" class="js-filter-link">Link to item</a>
   <span class="filter-item-active_label">⏎ Choose</span>
 </div>


 <!-- Empty state -->
 <div class="js-filter-item js-filter-empty empty-state" style="display:none;">
   <h4 class="empty-state_title">No results</h4>
   <div class="empty-state_actions"><p>Some message with actions</p></div>
 </div>
 */
